<hpf-route-form
        [route]="route"
        [loading]="route.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-route-form>
